import { render } from "./AddEvent.vue?vue&type=template&id=0dd6a980&scoped=true"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"

import "./AddEvent.vue?vue&type=style&index=0&id=0dd6a980&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd6a980"]])

export default __exports__